import type { Resources, ResourceType } from '@/models/types';
import { INITIAL_RESOURCES, RESOURCE_TYPES } from '@/models/constants';

export class ResourceManager {
  private resources: Resources = { ...INITIAL_RESOURCES };

  get(type: ResourceType): number {
    return this.resources[type];
  }

  getAll(): Resources {
    return { ...this.resources };
  }

  setAll(resources: Resources): void {
    this.resources = { ...resources };
  }

  add(amount: Resources): void {
    for (const rt of RESOURCE_TYPES) {
      this.resources[rt] += amount[rt];
    }
  }

  subtract(cost: Resources): void {
    for (const rt of RESOURCE_TYPES) {
      this.resources[rt] = Math.max(0, this.resources[rt] - cost[rt]);
    }
  }

  canAfford(cost: Resources): boolean {
    return RESOURCE_TYPES.every(rt => this.resources[rt] >= cost[rt]);
  }
}
